/**
 * PublicTagBadges — renders a delimited field value as individual tag
 * badges. Shared by every public layout that shows the mapped Description
 * field, rendered directly below it.
 */

import React from 'react';

// Relative luminance test so badge text stays legible against any
// admin-chosen background color.
function isDarkBg(hex) {
  if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 < 128;
}

// A record only ever uses one separator style, not both at once — so the
// delimiter is detected, not applied together. Comma is checked first.
const DELIMITERS = [',', '|'];

function splitTags(value) {
  const str = String(value);
  const delimiter = DELIMITERS.find(d => str.includes(d));
  const parts = delimiter ? str.split(delimiter) : [str];
  return parts.map(t => t.trim()).filter(Boolean);
}

export default function PublicTagBadges({ value, bgColor, accentColor }) {
  if (value === null || value === undefined || value === '') return null;

  const tags = splitTags(value);

  if (tags.length === 0) return null;

  const bg = bgColor || accentColor || '#6366f1';
  const textColor = isDarkBg(bg) ? '#f8fafc' : '#1e293b';

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {tags.map((tag, idx) => (
        <span
          key={`${tag}-${idx}`}
          style={{
            display: 'inline-block',
            background: bg,
            color: textColor,
            fontSize: '0.72rem',
            fontWeight: 600,
            padding: '3px 10px',
            borderRadius: 6,
            lineHeight: 1.4,
          }}
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
